export default __webpack_public_path__ + "static/media/Domenico Quirico e Giuria.a7a27d0b.jpg";